import { render, staticRenderFns } from "./SingleFilter.vue?vue&type=template&id=45793216"
import script from "./SingleFilter.vue?vue&type=script&lang=js"
export * from "./SingleFilter.vue?vue&type=script&lang=js"
import style0 from "./SingleFilter.vue?vue&type=style&index=0&id=45793216&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports